import { createSlice } from "@reduxjs/toolkit";
import { PATIENTSURGERY_STATES } from "../../doctor/data";
const initialState = {
  protocols: {
    data: [],
    isLoading: false,
    message: null,
  },
  patienSurgeryStates: {
    data: PATIENTSURGERY_STATES,
    isLoading: false,
    message: "carga de pacientes filtrados",
  },
};

export const selectOptionsSlice = createSlice({
  name: "selectOptions",
  initialState,
  reducers: {
    setSelectOptions(state, { payload }) {
      const { key, data } = payload;
      if (state[key]) {
        state[key].data = data;
        state[key].isLoading = false;
        state[key].message = {
          type: "successSelect",
          text: "protocolos obtenidos con exito",
        };
      }
    },
    setSelectLoading(state, { payload }) {
      const { key } = payload;
      if (state[key]) {
        state[key].isLoading = true;
        state[key].message = null;
      }
    },
    setSelectError(state, { payload }) {
      const { key, message } = payload;
      if (state[key]) {
        state[key].isLoading = false;
        state[key].message = {
          type: "errorSelect",
          text: message,
        };
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectOptions, setSelectLoading, setSelectError } =
  selectOptionsSlice.actions;
